import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { LoginResponse, WebServiceRegistryCode, WebServiceRegistryDto } from '../models/auth-models';
import { UrlConstants } from '../../models/url-constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _http = inject(HttpClient);

  $isUserLoggedIn(): Observable<boolean> {
    const token = sessionStorage.getItem('token');
    return of(!!token && token !== null);
  }

  $login(email: string, password: string): Observable<LoginResponse> {
    return this._http
      .post<LoginResponse>(UrlConstants.LOGIN_URL, {
        email,
        password,
      })
      .pipe(
        tap((response: LoginResponse) => {
          sessionStorage.setItem('token', response.token);
          sessionStorage.setItem('menu', JSON.stringify(response.menu));
          sessionStorage.setItem('username', response.username);
          sessionStorage.setItem('termsAndConditions', response.termsAndConditions ? 'SIGNED' : 'NOT_SIGNED');
        })
      );
  }

  public logout(): void {
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('menu');
    sessionStorage.removeItem('termsAndConditions');
    console.log('Removing all session data');
  }

  /**
   * Mock register method for creating a new user.
   * Returns an observable that resolves with a message and email.
   */
  $register(payload: WebServiceRegistryDto): Observable<WebServiceRegistryCode> {
    return this._http.post<WebServiceRegistryCode>(UrlConstants.REGISTER_URL, payload);
  }

  $verifyCode(payload: WebServiceRegistryCode): Observable<string> {
    return this._http.post(UrlConstants.VERIFY_CODE_URL, payload, { responseType: 'text' });
  }
}
